var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74891 4.89337L1.33435 0.243441C1.26184 0.166303 1.17557 0.105077 1.08053 0.0632943C0.985484 0.0215119 0.883539 0 0.780576 0C0.677612 0 0.575667 0.0215119 0.480622 0.0632943C0.385577 0.105077 0.299313 0.166303 0.226806 0.243441C0.081538 0.397639 0 0.606229 0 0.823653C0 1.04108 0.081538 1.24967 0.226806 1.40387L4.0876 5.51885L0.226806 9.59268C0.081538 9.74688 0 9.95547 0 10.1729C0 10.3903 0.081538 10.5989 0.226806 10.7531C0.299041 10.8309 0.385184 10.8927 0.480241 10.9351C0.575299 10.9775 0.677382 10.9995 0.780576 11C0.88377 10.9995 0.985853 10.9775 1.08091 10.9351C1.17597 10.8927 1.26211 10.8309 1.33435 10.7531L5.74891 6.10317C5.82808 6.02611 5.89126 5.93257 5.93447 5.82846C5.97769 5.72435 6 5.61193 6 5.49827C6 5.38461 5.97769 5.27219 5.93447 5.16808C5.89126 5.06397 5.82808 4.97044 5.74891 4.89337Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightangle);
export default __webpack_public_path__ + "static/media/rightangle.4fb668391d3b16a0a1054c4f3eda1345.svg";
export { ForwardRef as ReactComponent };